var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var accountPublickey;
var localApiURL = "http://127.0.0.1:47888/";

function logIfDebugEnabled(msg) {
  var debug = localStorage.getItem("DEBUG");

  if (debug === "true") {
    console.log("IN WALLET: " + msg);
  }
}

function makeSignatureProvider(network) {
  return {
    getAvailableKeys: function getAvailableKeys() {
      return __awaiter(this, void 0, void 0, function () {
        var resp, arr;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              logIfDebugEnabled("In getAvailableKeys");
              logIfDebugEnabled("Return Key: " + accountPublickey);
              return [4
              /*yield*/
              , fetch(localApiURL + "getPublicKeys")];

            case 1:
              resp = _a.sent();
              return [4
              /*yield*/
              , resp.json()];

            case 2:
              arr = _a.sent();
              return [2
              /*return*/
              , arr];
          }
        });
      });
    },
    sign: function sign(signatureProviderArgs) {
      return __awaiter(this, void 0, void 0, function () {
        var hexTrx, results, jsonData, signatureArray, response;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              logIfDebugEnabled("In Sign");
              hexTrx = Buffer.from(signatureProviderArgs.serializedTransaction).toString("hex");
              return [4
              /*yield*/
              , fetch(localApiURL + "sign", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json"
                },
                body: JSON.stringify({
                  hex_data: hexTrx
                })
              })];

            case 1:
              results = _a.sent();
              return [4
              /*yield*/
              , results.json()];

            case 2:
              jsonData = _a.sent();
              signatureArray = jsonData.sigs;
              response = {
                signatures: signatureArray,
                serializedTransaction: signatureProviderArgs.serializedTransaction
              };
              return [2
              /*return*/
              , response];
          }
        });
      });
    }
  };
}

function signArbitrary(data, userMessage) {
  return new Promise(function (resolve, reject) {
    reject("not implemented");
  });
}

export function myWalletProvider() {
  return function makeWalletProvider(network) {
    // Connection
    function connect(appName) {
      logIfDebugEnabled("The connect method of myWallet was called");

      var res = function m2() {
        return __awaiter(this, void 0, void 0, function () {
          var _r, e_1;

          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                _a.trys.push([0, 3,, 4]);

                return [4
                /*yield*/
                , fetch(localApiURL + "connect?appName=" + appName + "&chainId=" + network.chainId)];

              case 1:
                _r = _a.sent();
                return [4
                /*yield*/
                , _r.json()];

              case 2:
                return [2
                /*return*/
                , _a.sent()];

              case 3:
                e_1 = _a.sent();
                window.location.href = "simpleos://" + network.chainId;
                return [2
                /*return*/
                , false];

              case 4:
                return [2
                /*return*/
                ];
            }
          });
        });
      };

      return res();
    }

    function discover(discoveryOptions) {
      logIfDebugEnabled("The discover() method of myWallet was called"); // You probably do not need to implement this method.

      return new Promise(function (resolve, reject) {
        var discoveryInfo = {
          keys: [],
          note: "Wallet does not support discovery"
        };
        resolve(discoveryInfo);
      });
    }

    function disconnect() {
      return Promise.resolve(true);
    } // Authentication


    function login(accountName) {
      return __awaiter(this, void 0, void 0, function () {
        var url, resp, results;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              logIfDebugEnabled("The login method of myWallet was called");
              url = localApiURL + "login";
              logIfDebugEnabled("xx" + accountName);

              if (accountName) {
                url += "?account=" + accountName;
              }

              logIfDebugEnabled("1");
              return [4
              /*yield*/
              , fetch(url)];

            case 1:
              resp = _a.sent();
              console.log("resp");
              console.log(resp);
              return [4
              /*yield*/
              , resp.json()];

            case 2:
              results = _a.sent();
              accountPublickey = results.publicKey;
              console.log("accountPublickey");
              console.log(accountPublickey);

              if (accountPublickey === undefined) {
                // throw new Error("No account selected");
                return [2
                /*return*/
                , Promise.reject("No account selected")];
              }

              return [2
              /*return*/
              , {
                accountName: results.accountName,
                permission: results.permission,
                publicKey: accountPublickey
              }];
          }
        });
      });
    }

    function logout(accountName) {
      var res = function m2() {
        return __awaiter(this, void 0, void 0, function () {
          return __generator(this, function (_a) {
            return [2
            /*return*/
            , true];
          });
        });
      };

      return res();
    }

    var walletProvider = {
      id: "simpleos",
      meta: {
        name: "simplEOS",
        shortName: "simplEOS Wallet",
        description: "EOSIO Blockchain Interface & Wallet"
      },
      signatureProvider: makeSignatureProvider(network),
      connect: connect,
      discover: discover,
      disconnect: disconnect,
      login: login,
      logout: logout,
      signArbitrary: signArbitrary
    };
    return walletProvider;
  };
}
export default myWalletProvider;